type ScrollbarAxis = number | 'start' | 'end';

export class ScrollbarGeometry
{
    public x: number;
    public y: number;

    public w: number;
    public h: number;

    constructor(x: number, y: number, w: number, h: number)
    {
        this.x = x;
        this.y = y;
        this.w = w;
        this.h = h;
    }
}

export class ScrollbarPosition
{
    public x: ScrollbarAxis;
    public y: ScrollbarAxis;

    constructor(x: ScrollbarAxis, y: ScrollbarAxis)
    {
        this.x = x;
        this.y = y;
    }
}
